import React from 'react';
import loadable from '@loadable/component';
import { defineRoutes, RenderRoutes } from '@blocs.router';
import { useRemoveSplashLoader } from '@minecraft.utils';
import Loader from '@minecraft.loader';

const loaderFallback = { fallback: <Loader /> };

const OpenCallPage = loadable(
  () => import(/* webpackChunkName: "public-pages-open-call" */ './open-call/open-call'),
  loaderFallback
);

export const appRoutes = defineRoutes([
  {
    key: 'openCall',
    path: '/open-call/:projectSlug/:guid',
    exact: true,
    paramConstraints: { guid: 'uuid' },
    Page: OpenCallPage,
  },
  { key: 'openCallFallback', path: '*', Page: OpenCallPage },
] as const);

const Routes = (): JSX.Element => {
  useRemoveSplashLoader();
  return <RenderRoutes routeDefs={appRoutes} />;
};

export default Routes;
